import React, { useState, useEffect } from 'react';
import ProgressBar from 'react-bootstrap/ProgressBar';
import QuestionBody from '../../../components/question-components/QuestionBody';
import "../../../styles/pages-styles/main-dashboard-pages-styles/question-pages-styles/QuestionBank.css";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const Questionbank = () => {
  const navigate = useNavigate();
  const [questionCount, setQuestionCount] = useState(0);

  useEffect(() => {
    const fetchQuestionCount = async () => {
      try {
        const response = await axios.get('/user/getTotalQuestion'); 
        if (response.status === 200) {
          setQuestionCount(response.data.count);
        } else {
          console.error('Failed to fetch question count');
          // Optionally set a default value or handle the error
          setQuestionCount(0);
        }
      } catch (error) {
        console.error('Error fetching question count:', error);
        // Optionally set a default value or handle the error
        setQuestionCount(0);
      }
    };

    fetchQuestionCount();
  }, []);

  return (
    <div className="QuestionBank-container">
      <div className="question-bank-header">
        <div>
          <h1>Question Bank</h1>
          <p>Welcome to the main question bank. </p>

        </div>
        <div className="question-bank-buttons">
          <button className="question-bank-button1">{questionCount} questions found</button>
          <button
            className="question-bank-button2"
            onClick={() => {
              navigate("/starter-question");
            }}
          >
            Start with the questions {'>'}
          </button>
        </div>
      </div>

      <div>
        <QuestionBody />
      </div>
    </div>
  );
}

export default Questionbank;